<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>发送对象</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">选择范围</div>
              <el-radio-group v-model="allSendFlag">
                <el-radio label="yes">全部会员</el-radio>
                <el-radio label="no">部分会员</el-radio>
              </el-radio-group>
            </div>
            <div class="flex-row mb30" v-if="allSendFlag == 'no'">
              <div class="itemName">选择会员</div>
              <div class="itemNum isBlue cur" @click="selectMember">请选择</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">会员数量</div>
              <div class="itemNum isBlue cur">{{ allSendFlag == '' ? 0 : allSendFlag == 'yes' ? totalCount:memberList.length  }}人</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>发送主题</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">{{smsTemplateItem.name || '选择短信模板'}}</div>
              <div class="itemNum isBlue cur" @click="selectTemplates">选择主题</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="smsTemplateDetail.id"><span class="blueBlock"></span><i>发送内容</i></p>
          <div class="totals-box pl24" v-if="smsTemplateDetail.id">
            <div class="flex-row mb30">
              <div class="itemName">模板内容</div>
              <div class="itemNum" v-html="smsTemplateDetail.showContentInfo"></div>
            </div>
            <div v-for="item in smsTemplateDetail.itemList" :key="item.id">
              <div class="flex-row mb30">
                <div class="itemName">{{item.valueHint}}</div>
                <div class="itemNum">
                  <el-date-picker v-model="item.selectedDate" type="date" placeholder="时间起" value-format="yyyy-MM-dd" class="width140" @change="onChange" v-if="item.valueType == 'dateTime'"></el-date-picker>
                  <el-input v-model="item.text" :placeholder="item.valueHint" :maxlength="item.maxSize" class="width140" @input="onInput(item)" v-else></el-input>
                </div> 
              </div>
            </div>
          </div>
        </div>
        <div class="paperIndex-info">
          <p class="infos">温馨提示:</p>
          <p>短信长度=发送内容总字数；<br />
          短信长度不超过70个字，按照1条短信计费；<br />
          超过70个字即为长短信，将67字/条拆分成多条计费；<br />
          ${xxx}表示变量，部分变量可自定义填入，其余由系统在发送短信时填入。</p>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button type="primary" @click="save">确认</el-button>
        </div>
      </div>
    </drawer>
    <select-member ref="memberForm" @changeMember="changeMember"></select-member>
    <select-template ref="templateForm" @change="changeTemplate"></select-template>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import Dialog from "../../../components/common/dialog.vue";
import selectMember from "./checkMember.vue";
import selectTemplate from "./checkTemplate.vue";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: {
    drawer,
    Dialog,
    selectMember,
    selectTemplate
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "发送短信",
      form: {},
      memberList: [],
      smsTemplateItem: {},
      smsTemplateDetail: {},
      allSendFlag: '',
      totalCount: 0
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        if (org) {
          this.addEditShow = true;
        }
        this.form = {};
        this.smsTemplateItem = {};
        this.smsTemplateDetail = {};
        if (org.id) {
          this.memberList = [org];
        } else {
          this.memberList = [];
        }
        this.getMemberCount()
      });
    },
    getMemberCount () {
      this.$api.post(this.$url.smsTemplate.countByShopId, { start: 1, memberStatus: 'enable'}).then(res => {
        this.totalCount = res;
      }).catch(error => {});
    },
    onInput () {
      let msg = JSON.parse(JSON.stringify(this.smsTemplateDetail.contentDisplay))
      for (let index = 0; index < this.smsTemplateDetail.itemList.length; index++) {
        let item = this.smsTemplateDetail.itemList[index];
        if (item.text || item.selectedDate) msg = msg.replace(new RegExp('\\' + item.valueHint, 'g'),  `<span class="moneys">${item.text || item.selectedDate}</span>`  )
      }
      this.smsTemplateDetail.showContentInfo = msg;
    },
    onChange () {
      this.onInput()
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    selectMember () {
      this.$refs.memberForm.$emit("open", this.memberList)
    },
    selectTemplates  () {
      this.$refs.templateForm.$emit("open", this.smsTemplateItem)
    },
    changeMember (org) {
      if (org) {
        this.memberList = org;
      }
    },
    changeTemplate (org) {
      console.log(org);
      if (org) {
        this.smsTemplateItem = org;
        this.getSmsTemplateDetail(org.id)
      }
    },
    getSmsTemplateDetail (id) {
      /** 查询模板详情 */
      this.$api.get(this.$url.smsTemplate.smsTemplateDetail, {
        id:id
      }).then(res => {
        res.itemList.map(item => {
          item.selectedDate = '';
          item.text = '';
        })
        res.showContentInfo = res.contentDisplay;
        this.smsTemplateDetail = res;
      })
      .catch(error => {});
    },
    save () {
      if (this.allSendFlag == '') {
        this.$message.error("请选择发送范围");
        return false;
      } else if (this.memberList.length == 0 && this.allSendFlag == 'no') {
        this.$message.error("请选择会员");
        return false;
      } else if (!this.smsTemplateItem.id) {
        this.$message.error("请选择模板");
        return false;
      }
      for (let index = 0; index < this.smsTemplateDetail.itemList.length; index++) {
        let item = this.smsTemplateDetail.itemList[index];
        if (item.valueType == 'dateTime') {
          if (item.selectedDate == '' || !item.selectedDate) {
            this.$message.error("请选择时间");
            return false;
          }
        }else {
          if (item.inputSide == 'system') {

          }else {
            if (item.text == '' || !item.text) {
              this.$message.error("请输入对应内容");
              return false;
            }
          }
        }
      }
      this.$confirm('是否确定发送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let valueList = [];
        this.smsTemplateDetail.itemList.map(item => {
            let str = ''
            if (item.valueType == 'dateTime') {
              str = item.selectedDate;
            }else {
              str = item.text;
            }
            valueList.push({
              itemId:item.id,
              content: str,
              valueHint: item.valueHint
            });
          })
          let arr = encrypt(
            JSON.stringify({
              memberList: this.memberList,
              templateId: this.smsTemplateItem.id,
              valueList: valueList,
              content: this.smsTemplateDetail.contentDisplay,
              allSendFlag: this.allSendFlag
            })
          );
          this.$api.post(this.$url.smsTemplate.sendBatchSms, arr).then(res => {
            if (res && res.message) {
              this.$message.success(res.message);
              this.addEditShow = false;
              this.$emit("change", true);
            }
          }).catch(error => {});
      }).catch(() => {});
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .order-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }
}
.member-msg {
  padding: 16px 16px 0;
  .member-border {
    width: 100%;
    background-size: 100% 100%;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 12px 15px;
    background: #3388ff;
    box-sizing: border-box;
    .member-box {
      margin-left: 10px;
      .mobile {
        line-height: 1.6;
        margin-right: 20px;
      }
    }
  }
}
.paperIndex-info {
  width: calc(100% - 90px);
  margin: 0 24px;
  font-size: 16px;
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  color: #666;
  padding: 20px;
}
</style>
